import '../styles/Main.css';
import { Modal } from 'react-bootstrap';
import { useActions, useTypedSelector } from '../../hooks';
import Icon from '../../resources/images/register.webp';

const RegistrationModal: React.FC = () => {
  const needsRegistration = useTypedSelector(({ ui }) => {
    return ui.needsRegistration;
  });
  const { userNeedsRegistration } = useActions();
  return (
    <Modal
      show={needsRegistration}
      onHide={() => userNeedsRegistration(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="welcome-to-batu-popup"
      contentClassName="welcome-to-batu-popup-content"
    >
      <Modal.Body className="welcome-to-batu-popup-body">
        <div className="welcome-to-batu-popup-image-container">
          <img
            src={Icon}
            alt="Batu logo"
            className="welcome-to-batu-popup-image"
          />
        </div>
        <div className="welcome-to-batu-popup-iframe-container">
          <iframe
            title="welcome-to-batu-popup-iframe"
            className="welcome-to-batu-popup-iframe"
            src="https://noteforms.com/forms/bienvenido-a-bart-4v6jod"
          ></iframe>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export { RegistrationModal };
